import { inject, Injectable } from '@angular/core';
import { AppRole } from '@shared/auth/enums/app-role.enum';
import { AuthContextService } from '@shared/auth/services/auth-context.service';

@Injectable({ providedIn: 'root' })
export class RoleAccessService {
  private readonly authContext = inject(AuthContextService);

  getCurrentRole(): AppRole | null {
    return this.authContext.getCurrentRole();
  }

  hasRole(role: AppRole): boolean {
    return this.getCurrentRole() === role;
  }

  hasAnyRole(roles?: AppRole[] | null, role: string | null = this.getCurrentRole()): boolean {
    if (!roles?.length) {
      return true;
    }

    return !!role && roles.includes(role as AppRole);
  }

  isAdmin(): boolean {
    return this.hasRole(AppRole.ADMIN);
  }

  isManager(): boolean {
    return this.hasRole(AppRole.MANAGER);
  }
}
